namespace Matrix.Indexation {
    export interface IndexationProfileRow {
        IndexationProfileCode?: string;
        Name?: string;
        IndexationInstanceId?: string;
        EffectiveDate?: string;
        ValidFrom?: string;
        ValidTo?: string;
        ShortName?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
        SecurityList?: IndexationProfileSecurityRow[];
        CloningIndexationProfileCode?: string;
    }

    export namespace IndexationProfileRow {
        export const idProperty = 'IndexationProfileCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Indexation.IndexationProfile';
        export const deletePermission = 'DataAdmin:IndexationProfile';
        export const insertPermission = 'DataAdmin:IndexationProfile';
        export const readPermission = 'Read:IndexationProfile';
        export const updatePermission = 'DataAdmin:IndexationProfile';

        export declare const enum Fields {
            IndexationProfileCode = "IndexationProfileCode",
            Name = "Name",
            IndexationInstanceId = "IndexationInstanceId",
            EffectiveDate = "EffectiveDate",
            ValidFrom = "ValidFrom",
            ValidTo = "ValidTo",
            ShortName = "ShortName",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder",
            SecurityList = "SecurityList",
            CloningIndexationProfileCode = "CloningIndexationProfileCode"
        }
    }
}
